"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessType = exports.ObjectPermission = exports.DataAccessTypePlural = exports.DataAccessType = void 0;
var DataAccessType;
(function (DataAccessType) {
    DataAccessType["Object"] = "object";
    DataAccessType["Profile"] = "profile";
    DataAccessType["PermissionSet"] = "permissionSet";
    DataAccessType["Users"] = "user";
})(DataAccessType || (exports.DataAccessType = DataAccessType = {}));
exports.DataAccessTypePlural = {
    [DataAccessType.Object]: 'Objects',
    [DataAccessType.Profile]: 'Profiles',
    [DataAccessType.PermissionSet]: 'Permission Sets',
    [DataAccessType.Users]: 'Users'
};
var ObjectPermission;
(function (ObjectPermission) {
    ObjectPermission["create"] = "create";
    ObjectPermission["read"] = "read";
    ObjectPermission["edit"] = "edit";
    ObjectPermission["delete"] = "delete";
    ObjectPermission["viewAllData"] = "viewAllData";
    ObjectPermission["modifyAllData"] = "modifyAllData";
})(ObjectPermission || (exports.ObjectPermission = ObjectPermission = {}));
var AccessType;
(function (AccessType) {
    AccessType["Object"] = "Object";
    AccessType["PermissionSet"] = "PermissionSet";
    AccessType["Profile"] = "Profile";
    AccessType["User"] = "User";
})(AccessType || (exports.AccessType = AccessType = {}));
//# sourceMappingURL=DataAccessType.js.map